// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// TODO - add typedef here
const makeATPC = atpc => (
  atpc === null
    ? ({
      // If we want to remove ATPC, passing null for this is not sufficient. Instead we need to pass the object with atpcEnabled: false
      atpcEnabled: false,
    })
    : ({
      ...atpc,
      atpcEnabled: true,
    })
)

export default makeATPC
